import { useTranslation } from 'react-i18next'
import { FileText, ChevronRight } from 'lucide-react'
import type { TemplateListItem } from '../../services/templatesApi'

interface TemplateCardProps {
  template: TemplateListItem
  onSelect: () => void
}

/**
 * Compact template card for the task pane list.
 */
export function TemplateCard({ template, onSelect }: TemplateCardProps) {
  const { t } = useTranslation()

  return (
    <button
      onClick={onSelect}
      className="card-hover w-full flex items-center gap-3 p-3 rounded-lg border border-neutral-200 dark:border-neutral-700 hover:border-primary-300 dark:hover:border-primary-600 hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors text-left group"
    >
      <div className="shrink-0 w-9 h-9 rounded-lg bg-primary-50 dark:bg-primary-900/50 flex items-center justify-center">
        <FileText size={16} className="text-primary-500" />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-neutral-900 dark:text-neutral-100 truncate">
          {template.name}
        </p>
        <div className="flex items-center gap-1.5">
          {template.category && (
            <span className="text-[10px] text-neutral-400 dark:text-neutral-500">
              {template.category}
            </span>
          )}
          {template.variable_count > 0 && (
            <span className="text-[10px] text-neutral-400 dark:text-neutral-500">
              {template.variable_count} {t('templates.fieldsCount')}
            </span>
          )}
        </div>
      </div>

      <ChevronRight
        size={14}
        className="shrink-0 text-neutral-300 dark:text-neutral-600 group-hover:text-primary-500 transition-colors"
      />

      <span className="sr-only">{t('templates.useTemplate')}</span>
    </button>
  )
}
